module.exports = __webpack_public_path__ + "static/img/5.c90ccb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/people/5.png
// module id = S+vS
// module chunks = 1